<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { versioninfo } from "@/utils/api/common";
import { getToken } from "@/utils/h5Plus";
import version from "@/utils/version.js";
import { MessageBox, Toast } from "mint-ui";
import { useCounterStore } from "@/store/index";
import market from "@/utils/market.js";
export default {
  name: "App",
  mounted() {
    let that = this;

    versioninfo().then(({ data }) => {
      // 使用plus.runtime.restart()重启应用

      if (
        data.name != window.config.version &&
        process.env.NODE_ENV != "development"
      ) {
        MessageBox.confirm(that.$t("message.versionNew1"), {
          confirmButtonText: that.$t("message.upumme"),
          showCancelButton: false
        }).then(() => {
          that.clearCache();
        });
      }
    });
    let vConsole = null;
    if (process.env.NODE_ENV == "development" || window.config.isconsole) {
      // vConsole = new VConsole();
    }
    if (localStorage.getItem("lang")) {
      this.$i18n.locale = localStorage.getItem("lang");
    } else {
      this.$i18n.locale = "fcn";
    }

    if (window.plus) {
      this.plusReady();
    } else {
      document.addEventListener("plusready", this.plusReady(), false);
    }
  },

  methods: {
    updataapp() {
      var indexWebview = plus.webview.getLaunchWebview();
      var allWebviews = plus.webview.all();
      for (var i = 0; i < allWebviews.length; i++) {
        var webview = allWebviews[i];
        if (webview !== indexWebview) {
          webview.close("none"); // 使用'none'参数可避免动画效果
        }
      }
      setTimeout(() => {
        plus.runtime.restart();
      }, 200);
    },
    formatSize() {
      let that = this;
      plus.cache.calculate(function(size) {
        let sizeCache = parseInt(size);
        if (sizeCache == 0) {
          that.fileSizeString = "0B";
        } else if (sizeCache < 1024) {
          that.fileSizeString = sizeCache + "B";
        } else if (sizeCache < 1048576) {
          that.fileSizeString = (sizeCache / 1024).toFixed(2) + "KB";
        } else if (sizeCache < 1073741824) {
          that.fileSizeString = (sizeCache / 1048576).toFixed(2) + "MB";
        } else {
          that.fileSizeString = (sizeCache / 1073741824).toFixed(2) + "GB";
        }
      });
    },
    clearCache() {
      let that = this;
      let os = plus.os.name;
      if (os == "Android") {
        let main = plus.android.runtimeMainActivity();
        let sdRoot = main.getCacheDir();
        let files = plus.android.invoke(sdRoot, "listFiles");
        let len = files.length;
        for (let i = 0; i < len; i++) {
          let filePath = "" + files[i]; // 没有找到合适的方法获取路径，这样写可以转成文件路径
          plus.io.resolveLocalFileSystemURL(
            filePath,
            function(entry) {
              if (entry.isDirectory) {
                entry.removeRecursively(
                  function(entry) {
                    //递归删除其下的所有文件及子目录
                    uni.showToast({
                      title: "缓存清理完成",
                      duration: 2000
                    });

                    that.formatSize(); // 重新计算缓存
                  },
                  function(e) {
                    console.log(e.message);
                  }
                );
              } else {
                entry.remove();
              }
            },
            function(e) {
              console.log("文件路径读取失败");
            }
          );
        }

        // 使用plus.webview.getLaunchWebview()获取应用的首页Webview对象
        that.updataapp();
        // 使用indexWebview.reload(true)重新加载首页
      } else {
        setTimeout(() => {
          plus.runtime.restart();
        }, 200);
        // ios暂时未找到清理缓存的方法，以下是官方提供的方法，但是无效，会报错
        plus.cache.clear(function() {
          that.formatSize();
        });
      }
    },
    getOperatingSystem() {
      const userAgent = navigator.userAgent;

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      } else if (/Android/.test(userAgent)) {
        return "Android";
      } else {
        return "Unknown";
      }
    },

    plusReady() {
      let that = this;
      let osInfo = plus.os;
      // 在 Native.js 中调用原生方法启动 MainActivity
      var Intent = plus.android.importClass("h.wanli.two.MainActivity");
      // 导入后可以使用new方法创建类的实例对象
      var intent = new Intent();

      // Google渠道版本检查
      if (
        plus.runtime.version != window.config.apkver &&
        plus.runtime.channel == "google" &&
        osInfo.name === "Android"
      ) {
        MessageBox.confirm(that.$t("message.versionNew"), {
          confirmButtonText: that.$t("message.InstallNow")
        })
          .then(() => {
            market.open({
              android: "h.wanli.two"
            });
          })
          .catch(error => {
            console.error('Google版本更新失败:', error);
            Toast('更新失败，请稍后重试');
          });
      }

      // Android非Google渠道版本检查
      if (
        plus.runtime.version != window.config.andver &&
        plus.runtime.channel != "google" &&
        osInfo.name === "Android"
      ) {
        MessageBox.confirm(that.$t("message.versionNew"), {
          confirmButtonText: that.$t("message.InstallNow")
        })
          .then(() => {
            const hashWithHash = window.location.href; // 包含 #
            const parts = hashWithHash.split("#"); // 分割字符串
            const hashWithoutHash = parts[0]; // 取分割后的第二部分
            let uurl = `${hashWithoutHash}haowanli.apk`;
            if (process.env.NODE_ENV == "development") {
              uurl = "https://dev-app.howunlickltd.com/haowanli.apk";
            }
            version.downloadApkAndShowProgressForUpdate(uurl);
          })
          .catch(error => {
            console.error('Android版本更新失败:', error);
            Toast('更新失败，请稍后重试');
          });
      }
      console.log(plus.runtime);
      if (
        plus.runtime.version != window.config.iosver &&
        osInfo.name === "iOS" &&
        !window.config.isconsole
      ) {
        MessageBox.confirm(that.$t("message.versionNew"), {
          confirmButtonText: that.$t("message.upumme")
        })
          .then(() => {
            market.open({
              ios: "6462053731"
            });
          })
          .catch(error => {
            console.error('iOS版本更新失败:', error);
            Toast('更新失败，请稍后重试');
          });
        // plus.nativeUI.confirm("检测到新版本，是否立即安装？", function(e) {});
      }
      if (getToken()) {
        this.$router.push({ path: "/", replace: true });
      }
      plus.navigator.setStatusBarBackground("#F4f4f4");
      plus.navigator.setStatusBarStyle("dark");

      if (osInfo.name == "iOS") {
        let all = plus.webview.all();
        all.map((item, index) => {
          if (index > 0) {
            plus.webview.close(item.id);
          }
        });
        let currentWebview = plus.webview.currentWebview();
        currentWebview.setStyle({
          popGesture: "none",
          kernelRecovery: "restart",
          disableSwipeBack: true
        });
      }
    }
  }
};
</script>

<style>
#app {
  overflow-x: hidden;
  height: 100%;
  /*font-family: Roboto, Arial, Helvetica, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";*/
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f4f4f4;
}
</style>



// WEBPACK FOOTER //
// src/App.vue